import React from 'react';
import { Info, Send } from 'lucide-react';
import { useFormContext } from '../FormContext';
import { FormStep } from '../FormStep';
import { InfoBox } from '../InfoBox';
import { FormButtons } from '../FormButtons';
export const SummaryStep: React.FC = () => {
  const {
    formData,
    handleSubmit,
    goToPreviousStep,
    hasStructureOption,
    hasRoofOption,
    hasSchuifwanden,
    hasCarport,
    hasZonwering,
    hasTuinbestrating,
    hasSchutting,
    hasZandcement
  } = useFormContext();
  return <FormStep title="Controleer uw gegevens" description="Bekijk uw configuratie en verstuur uw aanvraag." isActive={true} data-id="element-1164">
      <div className="bg-white/10 rounded-lg p-6 mb-8" data-id="element-1165">
        <h3 className="text-xl font-bold text-white mb-4" data-id="element-1166">Uw project</h3>
        <div className="space-y-4 mb-6" data-id="element-1167">
          <div data-id="element-1168">
            <p className="text-white/60 text-sm" data-id="element-1169">Wat wilt u laten plaatsen?</p>
            <div className="flex flex-wrap gap-2 mt-1" data-id="element-1170">
              {formData.projectTypes.map(type => {
              // Map the project type ID to a readable name
              const projectTypeNames = {
                veranda: 'Veranda',
                overkapping: 'Overkapping',
                tuinkamer: 'Tuinkamer',
                schuifwanden: 'Schuifwanden',
                carport: 'Carport',
                tuinbestrating: 'Tuinbestrating',
                schutting: 'Schutting',
                zandcementvloer: 'Zandcementvloer',
                zonwering: 'Zonwering'
              };
              return <span key={type} className="px-2 py-1 bg-white/10 rounded-md text-sm text-white" data-id="element-1171">
                    {projectTypeNames[type] || type}
                  </span>;
            })}
            </div>
          </div>
          {hasStructureOption() && <>
              <div data-id="element-1172">
                <p className="text-white/60 text-sm" data-id="element-1173">Afmetingen</p>
                <div className="mt-1 space-y-1" data-id="element-1174">
                  <p className="text-white text-sm" data-id="element-1175">
                    <span className="text-white/60" data-id="element-1176">Tuin breedte:</span>{' '}
                    {formData.gardenWidth} cm
                  </p>
                  <p className="text-white text-sm" data-id="element-1177">
                    <span className="text-white/60" data-id="element-1178">Veranda diepte:</span>{' '}
                    {formData.verandaDepth} cm
                  </p>
                </div>
              </div>
            </>}
          {hasStructureOption() && formData.color && <div data-id="element-1179">
              <p className="text-white/60 text-sm" data-id="element-1180">Kleur constructie</p>
              <p className="text-white capitalize" data-id="element-1181">
                {formData.color === 'antraciet' ? 'Antraciet (RAL 7016)' : formData.color === 'gitzwart' ? 'Gitzwart (RAL 9005)' : formData.color === 'metallic-grijs' ? 'Metallic grijs (RAL 9007)' : 'Verkeerswit (RAL 9016)'}
              </p>
            </div>}
          {hasRoofOption() && formData.roofMaterial && <div data-id="element-1182">
              <p className="text-white/60 text-sm" data-id="element-1183">Dakbedekking</p>
              <p className="text-white capitalize" data-id="element-1184">
                {formData.roofMaterial === 'glas-helder' ? 'Glas helder' : formData.roofMaterial === 'glas-getint' ? 'Glas getint' : formData.roofMaterial === 'polycarbonaat-opaal' ? 'Polycarbonaat opaal' : 'Polycarbonaat helder'}
              </p>
            </div>}
          {hasStructureOption() && <div data-id="element-1185">
              <p className="text-white/60 text-sm" data-id="element-1186">LED Verlichting</p>
              <p className="text-white" data-id="element-1187">
                {formData.ledSpots === 10 ? '10 LED spots (standaard inbegrepen)' : `${formData.ledSpots} LED spots (10 standaard + ${formData.ledSpots - 10} extra)`}
              </p>
            </div>}
          {hasStructureOption() && <div data-id="element-1188">
              <p className="text-white/60 text-sm" data-id="element-1189">Extra elementen</p>
              <div className="mt-1 space-y-1" data-id="element-1190">
                <p className="text-white text-sm" data-id="element-1191">
                  <span className="text-white/60" data-id="element-1192">Zijwand links:</span>{' '}
                  {formData.leftSide === 'none' ? 'Geen zijkant' : formData.leftSide === 'aluminium-spie' ? 'Aluminium + spie polycarbonaat' : formData.leftSide === 'aluminium-compleet' ? 'Aluminium compleet' : formData.leftSide === 'glas' ? 'Glas' : 'Glazen schuifwand'}
                </p>
                <p className="text-white text-sm" data-id="element-1193">
                  <span className="text-white/60" data-id="element-1194">Zijwand rechts:</span>{' '}
                  {formData.rightSide === 'none' ? 'Geen zijkant' : formData.rightSide === 'aluminium-spie' ? 'Aluminium + spie polycarbonaat' : formData.rightSide === 'aluminium-compleet' ? 'Aluminium compleet' : formData.rightSide === 'glas' ? 'Glas' : 'Glazen schuifwand'}
                </p>
                <p className="text-white text-sm" data-id="element-1195">
                  <span className="text-white/60" data-id="element-1196">Voorkant:</span>{' '}
                  {formData.frontSide === 'open' ? 'Open' : formData.frontSide === 'schuifpui' ? 'Schuifpui' : 'Glazen schuifwand'}
                </p>
              </div>
            </div>}
          {hasSchuifwanden() && formData.schuifwandType && <>
              <div data-id="element-1197">
                <p className="text-white/60 text-sm" data-id="element-1198">Type schuifwand</p>
                <p className="text-white capitalize" data-id="element-1199">
                  {formData.schuifwandType === 'aluminium' ? 'Aluminium schuifwand' : formData.schuifwandType === 'glas' ? 'Glazen schuifwand' : 'Vouwwand'}
                </p>
              </div>
              <div data-id="element-1200">
                <p className="text-white/60 text-sm" data-id="element-1201">Kleur schuifwand</p>
                <p className="text-white capitalize" data-id="element-1202">
                  {formData.schuifwandColor === 'antraciet' ? 'Antraciet (RAL 7016)' : formData.schuifwandColor === 'gitzwart' ? 'Gitzwart (RAL 9005)' : formData.schuifwandColor === 'metallic-grijs' ? 'Metallic grijs (RAL 9007)' : 'Verkeerswit (RAL 9016)'}
                </p>
              </div>
            </>}
          {hasCarport() && formData.carportRoof && <>
              <div data-id="element-1203">
                <p className="text-white/60 text-sm" data-id="element-1204">Dakbedekking carport</p>
                <p className="text-white capitalize" data-id="element-1205">
                  {formData.carportRoof === 'polycarbonaat-helder' ? 'Polycarbonaat helder' : formData.carportRoof === 'polycarbonaat-opaal' ? 'Polycarbonaat opaal' : 'Glas helder'}
                </p>
              </div>
              <div data-id="element-1206">
                <p className="text-white/60 text-sm" data-id="element-1207">Kleur carport</p>
                <p className="text-white capitalize" data-id="element-1208">
                  {formData.carportColor === 'antraciet' ? 'Antraciet (RAL 7016)' : formData.carportColor === 'gitzwart' ? 'Gitzwart (RAL 9005)' : formData.carportColor === 'metallic-grijs' ? 'Metallic grijs (RAL 9007)' : 'Verkeerswit (RAL 9016)'}
                </p>
              </div>
            </>}
          {hasTuinbestrating() && <>
              <div data-id="element-1209">
                <p className="text-white/60 text-sm" data-id="element-1210">
                  Tuinbestrating afmetingen
                </p>
                <div className="mt-1 space-y-1" data-id="element-1211">
                  <p className="text-white text-sm" data-id="element-1212">
                    <span className="text-white/60" data-id="element-1213">Lengte:</span>{' '}
                    {formData.tuinbestratingLength} cm
                  </p>
                  <p className="text-white text-sm" data-id="element-1214">
                    <span className="text-white/60" data-id="element-1215">Breedte:</span>{' '}
                    {formData.tuinbestratingWidth} cm
                  </p>
                </div>
              </div>
              {formData.tuinbestratingRemarks && <div data-id="element-1216">
                  <p className="text-white/60 text-sm" data-id="element-1217">
                    Extra opmerkingen tuinbestrating
                  </p>
                  <p className="text-white text-sm" data-id="element-1218">
                    {formData.tuinbestratingRemarks}
                  </p>
                </div>}
            </>}
          {hasSchutting() && <>
              <div data-id="element-1219">
                <p className="text-white/60 text-sm" data-id="element-1220">Schutting afmetingen</p>
                <div className="mt-1 space-y-1" data-id="element-1221">
                  <p className="text-white text-sm" data-id="element-1222">
                    <span className="text-white/60" data-id="element-1223">Lengte:</span>{' '}
                    {formData.schuttingLength} cm
                  </p>
                  <p className="text-white text-sm" data-id="element-1224">
                    <span className="text-white/60" data-id="element-1225">Hoogte:</span>{' '}
                    {formData.schuttingHeight} cm
                  </p>
                </div>
              </div>
              {formData.schuttingRemarks && <div data-id="element-1226">
                  <p className="text-white/60 text-sm" data-id="element-1227">
                    Extra opmerkingen schutting
                  </p>
                  <p className="text-white text-sm" data-id="element-1228">
                    {formData.schuttingRemarks}
                  </p>
                </div>}
            </>}
          {hasZandcement() && <>
              <div data-id="element-1229">
                <p className="text-white/60 text-sm" data-id="element-1230">
                  Zandcement vloer afmetingen
                </p>
                <div className="mt-1 space-y-1" data-id="element-1231">
                  <p className="text-white text-sm" data-id="element-1232">
                    <span className="text-white/60" data-id="element-1233">Lengte:</span>{' '}
                    {formData.zandcementLength} cm
                  </p>
                  <p className="text-white text-sm" data-id="element-1234">
                    <span className="text-white/60" data-id="element-1235">Breedte:</span>{' '}
                    {formData.zandcementWidth} cm
                  </p>
                </div>
              </div>
              {formData.zandcementRemarks && <div data-id="element-1236">
                  <p className="text-white/60 text-sm" data-id="element-1237">
                    Extra opmerkingen zandcement vloer
                  </p>
                  <p className="text-white text-sm" data-id="element-1238">
                    {formData.zandcementRemarks}
                  </p>
                </div>}
            </>}
          <div data-id="element-1239">
            <p className="text-white/60 text-sm" data-id="element-1240">Montage</p>
            <p className="text-white" data-id="element-1241">Inclusief vakkundige montage</p>
          </div>
        </div>
        <div className="border-t border-white/20 pt-4 mt-6" data-id="element-1242">
          <h3 className="text-xl font-bold text-white mb-4" data-id="element-1243">Uw gegevens</h3>
          <div className="space-y-4" data-id="element-1244">
            <div data-id="element-1245">
              <p className="text-white/60 text-sm" data-id="element-1246">Naam</p>
              <p className="text-white" data-id="element-1247">{formData.name}</p>
            </div>
            <div data-id="element-1248">
              <p className="text-white/60 text-sm" data-id="element-1249">E-mailadres</p>
              <p className="text-white" data-id="element-1250">{formData.email}</p>
            </div>
            <div data-id="element-1251">
              <p className="text-white/60 text-sm" data-id="element-1252">Telefoonnummer</p>
              <p className="text-white" data-id="element-1253">{formData.phone}</p>
            </div>
            {formData.message && <div data-id="element-1254">
                <p className="text-white/60 text-sm" data-id="element-1255">Toelichting</p>
                <p className="text-white" data-id="element-1256">{formData.message}</p>
              </div>}
          </div>
        </div>
      </div>
      <InfoBox icon={<Info data-id="element-1258" />} data-id="element-1257">
        Door op "Offerte aanvragen" te klikken, stuurt u deze gegevens naar ons.
        We nemen binnen 48 uur contact met u op om uw wensen te bespreken.
        Verdere details zullen telefonisch met u worden doorgenomen.
      </InfoBox>
      <FormButtons onPrevious={goToPreviousStep} onNext={handleSubmit} nextText="Offerte aanvragen" nextIcon={<Send className="ml-2 h-5 w-5" data-id="element-1260" />} data-id="element-1259" />
    </FormStep>;
};